import React, { useContext, ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';
import AuthContext from '@packages/contexts/auth/authContext';

import { Role } from '../../../types/Auth';
import { CLIENT_STATUS } from '../../../types/Client';

import JSONTransformSection from '../../../components/Feature/JSONTransform/JSONTransformSection';
import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitJsonTransformConfigFactory } from '../utils/submit';

const ClientJsonTransformForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, reload, resetFormFlag } = useClientFormContext();
    const { user } = useContext(AuthContext);

    const renderJSONTransformComponent = (form: FormInstance): JSX.Element | null => {
        if (!user || (user.role !== Role.StuartStaff && user.role !== Role.SE)) {
            return <span>You need another role to be able to edit this page.</span>;
        }
        return (
            <JSONTransformSection
                formInstance={form}
                jsonTransformConfig={data.jsonTransform}
                isDetailMode={formConfig.isDetailMode}
                resetFormFlag={resetFormFlag}
                enableControls={client?.status !== CLIENT_STATUS.DELETED}
            />
        );
    };

    return (
        <div className="shadow-sm pb-4">
            <ClientFormHeader />
            <div className="px-4">
                <ClientForm
                    name="json-transform"
                    submitForm={client && submitJsonTransformConfigFactory(client.id, user, data.jsonTransform, reload)}
                >
                    {({ form }): ReactElement | null => renderJSONTransformComponent(form)}
                </ClientForm>
            </div>
        </div>
    );
};

export default ClientJsonTransformForm;
